import Big from 'big.js';
import * as bootstrap from 'bootstrap';
import * as models from 'smg/customer-api/models';
import { OrderAggregates, Orders } from 'smg/customer-api/orders';
import * as session from 'smg/customer-api/session';
import { DollarFormat } from 'smg/util';
import { AccountReady } from '../account-session';
import * as payments from '../payments';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const loader = document.querySelector('#dashboard-loader') as HTMLElement;
    const identity = document.querySelector('#account-identity') as HTMLElement;

    const accountBalance = document.querySelector('#account-balance') as HTMLElement;
    const accountBalanceAmount = accountBalance.querySelector('#account-balance-amount') as HTMLElement;

    const availableDiscount = document.querySelector('#available-discount') as HTMLElement;
    const availableDiscountAmount = availableDiscount.querySelector('#available-discount-amount') as HTMLElement;
    const availableDiscountOrigin = availableDiscount.querySelector('#available-discount-origin') as HTMLElement;

    const firstTimer = document.querySelector('#first-timer') as HTMLElement;

    const orderHistory = document.querySelector('#order-history') as HTMLElement;
    const orderHistoryCount = orderHistory.querySelector('#order-history-count') as HTMLElement;
    const orderHistoryTotal = orderHistory.querySelector('#order-history-total') as HTMLElement;

    const unpaidEl = document.querySelector('#unpaid') as HTMLElement;
    const unpaidCountEl = unpaidEl.querySelector('#unpaid-count') as HTMLElement;
    const unpaidTotalEl = unpaidEl.querySelector('#unpaid-total') as HTMLElement;
    const unpaidPayEl = unpaidEl.querySelector('#unpaid-pay') as HTMLElement;

    const showCards: HTMLElement[] = [];

    const sess = session.Session();
    const discount = session.SessionWith(['availableDiscount']);

    await Promise.all([sess, discount]).then(([sess, discount]) => {
        const name = `${sess.user.firstName} ${sess.user.lastName}`.trim();
        const identityParts: string[] = [];
        if (name !== '') {
            identityParts.push(name);
        }
        if (sess.user.company !== '') {
            identityParts.push(sess.user.company);
        }
        if (identityParts.length) {
            identity.textContent = identityParts.join(' · ');
            identity.classList.remove('d-none');
        }

        if (sess.user.balance?.gt('0')) {
            accountBalanceAmount.textContent = DollarFormat(sess.user.balance);
            showCards.push(accountBalance);
        }

        if (discount.user.availableDiscount.gt('0')) {
            availableDiscountAmount.textContent = DollarFormat(discount.user.availableDiscount);
            bootstrap.Collapse.getOrCreateInstance(availableDiscountOrigin, { toggle: false });
            showCards.push(availableDiscount);
        }
    });

    // The card reads "$X is what you have paid us", so it sums paid, not total.
    const ordersStats = OrderAggregates('', ['id', 'paid']).then(resp => {
        const count = resp.aggregates.get('id')?.count ?? 0;
        if (count) {
            orderHistoryCount.textContent = count.toLocaleString();
            showCards.push(orderHistory);
        }

        const paid = Big(resp.aggregates.get('paid')?.sum ?? 0);
        if (paid.eq(0)) {
            return;
        }

        orderHistoryTotal.textContent = DollarFormat(paid);
        showCards.push(orderHistory);
    });

    const unpaidParams = {
        'q': 'balance:>=.01',
        'data': 'balance',
        'max': 9999,
    };
    const unpaidOrders = Orders(unpaidParams).then(data => {
        if (!data.results.length) {
            return;
        }

        const ids: string[] = [];
        let total = Big('0');

        const consumeResp = (orders: models.HyejooOrder[]) => {
            ids.length = 0;
            total = Big('0');
            for (const order of orders) {
                ids.push(order.id);
                total = total.add(order.balance);
            }

            unpaidCountEl.textContent = `${orders.length.toLocaleString()} ${orders.length === 1 ? 'Order' : 'Orders'}`;
            unpaidTotalEl.textContent = DollarFormat(total);
        };

        consumeResp(data.results);

        unpaidPayEl.addEventListener('click', () => payments.PromptPayment(undefined, ids, total).
            then(() => Orders(unpaidParams).then(data => {
                consumeResp(data.results);
                if (total.lt('.01')) {
                    unpaidEl.parentElement?.removeChild(unpaidEl);
                }
            })));

        showCards.push(unpaidEl);
    });

    await sess;
    await ordersStats;
    await unpaidOrders;

    if (!showCards.length) {
        firstTimer.classList.remove('d-none');
    } else {
        showCards.forEach(el => el.classList.remove('d-none'));
    }

    loader.parentElement?.removeChild(loader);
}
